import { render, staticRenderFns } from "./BalanceKpisTab.vue?vue&type=template&id=3fae72ae&scoped=true"
import script from "./BalanceKpisTab.vue?vue&type=script&lang=js"
export * from "./BalanceKpisTab.vue?vue&type=script&lang=js"
import style0 from "./BalanceKpisTab.vue?vue&type=style&index=0&id=3fae72ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fae72ae",
  null
  
)

export default component.exports